export default __webpack_public_path__ + "static/media/registration.47e4edcd.svg";